import { Clock, Square, Zap, TrendingDown, CornerUpRight, Gauge } from "lucide-react";

// Catalogue des événements d'un trajet : libellé, couleur, logo (icône Lucide).
export const EVENT_TYPES = {
  idle: { label: "Ralenti", color: "#F59E0B", Icon: Clock },
  stop: { label: "Arrêt", color: "#EF4444", Icon: Square },
  harsh_accel: { label: "Accélération", color: "#3B82F6", Icon: Zap },
  harsh_brake: { label: "Freinage", color: "#A855F7", Icon: TrendingDown },
  cornering: { label: "Virage", color: "#EAB308", Icon: CornerUpRight },
  overspeed: { label: "Excès vitesse", color: "#EC4899", Icon: Gauge },
};

export const EVENT_ORDER = ["idle", "stop", "harsh_accel", "harsh_brake", "cornering", "overspeed"];
